import { useOutletContext } from 'react-router-dom'

import { Box, useBreakpoint } from '@factorialco/deprecated-design-system'
import { PerformanceReviewOverviewTasksDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

import { ParticipationRateTask } from './ParticipationRate'
import { PeerAssignmentTask } from './PeerAssignment'
import { PendingAgreementsTask } from './PendingAgreements'
import { PendingEvaluationsTask } from './PendingEvaluations'

interface Props {
  hideParticipationRate?: boolean
}

export const Tasks = ({ hideParticipationRate = false }: Props) => {
  const { access, employee } = useCurrentSession()
  const context = useOutletContext<ReviewOverviewOutletContext>()

  const { breakpoint, isMobile } = useBreakpoint()
  const showCarousel = breakpoint === 'xl' || breakpoint === 'l'
  const minCardWidth = showCarousel ? 's360' : 'full'

  const { data, loading } = useQuery(PerformanceReviewOverviewTasksDocument, {
    variables: {
      reviewProcessId: context.reviewProcess.id,
      currentAccessId: access.id,
      directlyManagedByCurrentEmployeeFilter: employee?.id
        ? {
            managerEmployeeId: employee.id,
            onlyDirectReports: true,
          }
        : undefined,
      participationRateManagerFilter:
        !context.reviewProcess._policies?.fullVisibility.can && employee?.id
          ? { managerEmployeeId: employee?.id, onlyDirectReports: false }
          : undefined,
    },
  })

  const reviewProcess = data?.performance.reviewProcess

  if (loading || !reviewProcess) return null

  return (
    <Box
      gap="s16"
      overflowX="auto"
      flexWrap="noWrap"
      style={
        isMobile || showCarousel
          ? {
              flexDirection: showCarousel ? 'row' : 'column',
            }
          : {
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
            }
      }
    >
      {!hideParticipationRate && (
        <ParticipationRateTask reviewProcess={reviewProcess} minWidth={minCardWidth} />
      )}
      {<PendingEvaluationsTask reviewProcess={reviewProcess} minWidth={minCardWidth} />}
      {employee && <PendingAgreementsTask reviewProcess={reviewProcess} minWidth={minCardWidth} />}
      {<PeerAssignmentTask reviewProcess={reviewProcess} minWidth={minCardWidth} />}
    </Box>
  )
}
